/* tslint:disable */
/* eslint-disable */
/**
 * Limber Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    OrganizationDetails,
    OrganizationDetailsFromJSON,
    OrganizationDetailsToJSON,
    PatientData,
    PatientDataFromJSON,
    PatientDataToJSON,
    PhysicianToRegister,
    PhysicianToRegisterFromJSON,
    PhysicianToRegisterToJSON,
    PrivateOrganizationDetails,
    PrivateOrganizationDetailsFromJSON,
    PrivateOrganizationDetailsToJSON,
    ProgramDataDownload,
    ProgramDataDownloadFromJSON,
    ProgramDataDownloadToJSON,
    RegisteredPhysician,
    RegisteredPhysicianFromJSON,
    RegisteredPhysicianToJSON,
    StatisticsData,
    StatisticsDataFromJSON,
    StatisticsDataToJSON,
    VersionResponse,
    VersionResponseFromJSON,
    VersionResponseToJSON,
    VideosAnalyticsData,
    VideosAnalyticsDataFromJSON,
    VideosAnalyticsDataToJSON,
} from '../models';

export interface PhysicianAccountsRegisterPostRequest {
    physicianToRegister: PhysicianToRegister;
}

export interface ProgramDataGetRequest {
    organizationId?: number;
    program?: string;
    registrationDateMin?: Date;
    registrationDateMax?: Date;
}

export interface StatisticsGetRequest {
    organizationId?: number;
    program?: string;
    registrationDateMin?: Date;
    registrationDateMax?: Date;
}

export interface VideoAnalyticsGetRequest {
    organizationId?: number;
    program?: string;
    registrationDateMin?: Date;
    registrationDateMax?: Date;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Get all organizations (only for admins).
     */
    async organizationsGetRaw(): Promise<runtime.ApiResponse<Array<OrganizationDetails>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/organizations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrganizationDetailsFromJSON));
    }

    /**
     * Get all organizations (only for admins).
     */
    async organizationsGet(): Promise<Array<OrganizationDetails>> {
        const response = await this.organizationsGetRaw();
        return await response.value();
    }

    /**
     * Get information about the authenticated physician\'s organization.
     */
    async organizationsMineGetRaw(): Promise<runtime.ApiResponse<PrivateOrganizationDetails>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/organizations/mine`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PrivateOrganizationDetailsFromJSON(jsonValue));
    }

    /**
     * Get information about the authenticated physician\'s organization.
     */
    async organizationsMineGet(): Promise<PrivateOrganizationDetails> {
        const response = await this.organizationsMineGetRaw();
        return await response.value();
    }

    /**
     * Get information about the authenticated physician\'s patients.
     */
    async patientsGetRaw(): Promise<runtime.ApiResponse<Array<PatientData>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/patients`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatientDataFromJSON));
    }

    /**
     * Get information about the authenticated physician\'s patients.
     */
    async patientsGet(): Promise<Array<PatientData>> {
        const response = await this.patientsGetRaw();
        return await response.value();
    }

    /**
     * Register a physician account.
     */
    async physicianAccountsRegisterPostRaw(requestParameters: PhysicianAccountsRegisterPostRequest): Promise<runtime.ApiResponse<RegisteredPhysician>> {
        if (requestParameters.physicianToRegister === null || requestParameters.physicianToRegister === undefined) {
            throw new runtime.RequiredError('physicianToRegister','Required parameter requestParameters.physicianToRegister was null or undefined when calling physicianAccountsRegisterPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/physician-accounts/register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PhysicianToRegisterToJSON(requestParameters.physicianToRegister),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RegisteredPhysicianFromJSON(jsonValue));
    }

    /**
     * Register a physician account.
     */
    async physicianAccountsRegisterPost(requestParameters: PhysicianAccountsRegisterPostRequest): Promise<RegisteredPhysician> {
        const response = await this.physicianAccountsRegisterPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a URL to download program data for all users (optionally filtered) as a zip file.
     */
    async programDataGetRaw(requestParameters: ProgramDataGetRequest): Promise<runtime.ApiResponse<ProgramDataDownload>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.organizationId !== undefined) {
            queryParameters['organization-id'] = requestParameters.organizationId;
        }

        if (requestParameters.program !== undefined) {
            queryParameters['program'] = requestParameters.program;
        }

        if (requestParameters.registrationDateMin !== undefined) {
            queryParameters['registration-date-min'] = (requestParameters.registrationDateMin as any).toISOString();
        }

        if (requestParameters.registrationDateMax !== undefined) {
            queryParameters['registration-date-max'] = (requestParameters.registrationDateMax as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/program-data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramDataDownloadFromJSON(jsonValue));
    }

    /**
     * Get a URL to download program data for all users (optionally filtered) as a zip file.
     */
    async programDataGet(requestParameters: ProgramDataGetRequest): Promise<ProgramDataDownload> {
        const response = await this.programDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get analytics and statistics for the admin/physician portal.
     */
    async statisticsGetRaw(requestParameters: StatisticsGetRequest): Promise<runtime.ApiResponse<StatisticsData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.organizationId !== undefined) {
            queryParameters['organization-id'] = requestParameters.organizationId;
        }

        if (requestParameters.program !== undefined) {
            queryParameters['program'] = requestParameters.program;
        }

        if (requestParameters.registrationDateMin !== undefined) {
            queryParameters['registration-date-min'] = (requestParameters.registrationDateMin as any).toISOString();
        }

        if (requestParameters.registrationDateMax !== undefined) {
            queryParameters['registration-date-max'] = (requestParameters.registrationDateMax as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/statistics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StatisticsDataFromJSON(jsonValue));
    }

    /**
     * Get analytics and statistics for the admin/physician portal.
     */
    async statisticsGet(requestParameters: StatisticsGetRequest): Promise<StatisticsData> {
        const response = await this.statisticsGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Show API version
     */
    async versionGetRaw(): Promise<runtime.ApiResponse<VersionResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/version`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VersionResponseFromJSON(jsonValue));
    }

    /**
     * Show API version
     */
    async versionGet(): Promise<VersionResponse> {
        const response = await this.versionGetRaw();
        return await response.value();
    }

    /**
     * Get analytics and statistics for the admin/physician portal.
     */
    async videoAnalyticsGetRaw(requestParameters: VideoAnalyticsGetRequest): Promise<runtime.ApiResponse<VideosAnalyticsData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.organizationId !== undefined) {
            queryParameters['organization-id'] = requestParameters.organizationId;
        }

        if (requestParameters.program !== undefined) {
            queryParameters['program'] = requestParameters.program;
        }

        if (requestParameters.registrationDateMin !== undefined) {
            queryParameters['registration-date-min'] = (requestParameters.registrationDateMin as any).toISOString();
        }

        if (requestParameters.registrationDateMax !== undefined) {
            queryParameters['registration-date-max'] = (requestParameters.registrationDateMax as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/video-analytics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VideosAnalyticsDataFromJSON(jsonValue));
    }

    /**
     * Get analytics and statistics for the admin/physician portal.
     */
    async videoAnalyticsGet(requestParameters: VideoAnalyticsGetRequest): Promise<VideosAnalyticsData> {
        const response = await this.videoAnalyticsGetRaw(requestParameters);
        return await response.value();
    }

}
